module.exports = __webpack_public_path__ + "img/0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e.4c209327.png";